import { __decorate } from "tslib";
import { Component, Mixins } from "vue-property-decorator";
import TeamOperationsSectionEditMixin from "./TeamOperationsSectionEditMixin";
import TeamOperationsFieldInput from "./TeamOperationsFieldInput.vue";
import TeamOperationsEditFooter from "./TeamOperationsEditFooter.vue";
import SectionLoader from "@/components/widgets/SectionLoader.vue";
/**
 * Add / Edit Communication Channel: Media and Frequency per activity.
 */
let TeamOperationsCommunicationModal = /** @class */ (() => {
    let TeamOperationsCommunicationModal = class TeamOperationsCommunicationModal extends Mixins(TeamOperationsSectionEditMixin) {
    };
    TeamOperationsCommunicationModal = __decorate([
        Component({
            name: "TeamOperationsCommunicationModal",
            components: {
                SectionLoader,
                TeamOperationsFieldInput,
                TeamOperationsEditFooter,
            },
        })
    ], TeamOperationsCommunicationModal);
    return TeamOperationsCommunicationModal;
})();
export default TeamOperationsCommunicationModal;
